import _classCallCheck from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import Quill from "quill";
var InlineBlot = Quill.import("blots/block");

var LoadingImage = /*#__PURE__*/function (_InlineBlot) {
  _inherits(LoadingImage, _InlineBlot);

  var _super = _createSuper(LoadingImage);

  function LoadingImage() {
    _classCallCheck(this, LoadingImage);

    return _super.apply(this, arguments);
  }

  _createClass(LoadingImage, [{
    key: "deleteAt",
    value: function deleteAt(index, length) {
      _get(_getPrototypeOf(LoadingImage.prototype), "deleteAt", this).call(this, index, length);

      this.cache = {};
    }
  }], [{
    key: "create",
    value: function create(src) {
      var node = _get(_getPrototypeOf(LoadingImage), "create", this).call(this, src);

      if (src === true) return node;
      var image = document.createElement("img");
      image.setAttribute("src", src);
      node.appendChild(image);
      return node;
    }
  }, {
    key: "value",
    value: function value(domNode) {
      var _domNode$dataset = domNode.dataset,
          src = _domNode$dataset.src,
          custom = _domNode$dataset.custom;
      return {
        src: src,
        custom: custom
      };
    }
  }]);

  return LoadingImage;
}(InlineBlot);

LoadingImage.blotName = "imageBlot";
LoadingImage.className = "image-uploading";
LoadingImage.tagName = "span";
Quill.register({
  "formats/imageBlot": LoadingImage
});
export default LoadingImage;